import NonCriticalError from '@/errors/NonCriticalError.js';

class ForbiddenError extends NonCriticalError {
}

export default ForbiddenError;
